import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SettingsService } from '@core/services/settings.service';
import { IsMemberTypePipe } from '@features/product/pipes/member-type.pipe';
import { CampaignOnUsePipe } from '@features/product/pipes/campaign-on-use.pipe';
import { TranslateSafePipe } from '@shared/translate-safe/translate-safe.pipe';
import { TooltipComponent } from '@shared/tooltip/tooltip.component';
import { ProductCampaignComponent } from '@features/product/product-campaign/product-campaign.component';
import { ProductPriceAnydayComponent } from '@features/product/product-price-anyday/product-price-anyday.component';
import { AsyncPipe, NgClass, NgIf, NgSwitch, NgSwitchCase, NgTemplateOutlet } from '@angular/common';
import { ProductEnergyClassComponent } from '@features/product/product-energy-class/product-energy-class.component';
import { ProductLine } from '@features/product/product.models';

@Component({
    selector: 'app-product-price',
    templateUrl: './product-price.component.html',
    styleUrls: ['./product-price.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        NgClass,
        NgSwitch,
        NgSwitchCase,
        NgTemplateOutlet,
        ProductPriceAnydayComponent,
        ProductCampaignComponent,
        TooltipComponent,
        AsyncPipe,
        TranslateSafePipe,
        CampaignOnUsePipe,
        IsMemberTypePipe,
        ProductEnergyClassComponent
    ]
})
export class ProductPriceComponent {
    @Input()
    type: 'stacked' | 'lite' | 'regular' = 'stacked';

    @Input()
    pointPosition: 'left' | 'below' = 'below';

    @Input()
    showAnydayPriceTag: boolean = false;

    @Input()
    settings: {
        showPoints: boolean;
        forceEqualHeight: boolean;
    } = {
        showPoints: true,
        forceEqualHeight: true
    };

    @Input() line: ProductLine;

    constructor(public readonly settingsService: SettingsService) {}
}
